import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
const RussianBlockedBanner = () => {
  return /*#__PURE__*/_jsx(Alert, {
    type: "danger",
    maxInlineSize: "1400px",
    marginBlockStart: "0",
    marginInline: "auto",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "russianBlocked.alert.title"
    }),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "russianBlocked.alert.body"
    })
  });
};
export default RussianBlockedBanner;